function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Button from "@material-ui/core/Button/index";
import React, { Component } from "react";
import CustomLoader from "@common/components/CustomLoader";
import { ANIMATION_TIMEOUT, BILLING_FORM, DELIVERY_FORM, KEY_ENTER, KEY_SPACE } from "@config/constants";
import { isEmpty } from "lodash";
var UserAddress = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(UserAddress, Component);
    var _super = _create_super(UserAddress);
    function UserAddress(props) {
        _class_call_check(this, UserAddress);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            isComponentMounted: false
        };
        _this._isMounted = false;
        _this.animationTimeout = null;
        _this.toggleFromKeyboard = _this.toggleFromKeyboard.bind(_assert_this_initialized(_this));
        return _this;
    }
    _create_class(UserAddress, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this = this;
                this._isMounted = true;
                this.animationTimeout = setTimeout(function() {
                    if (_this._isMounted) {
                        _this.setState({
                            isComponentMounted: true
                        });
                    }
                }, ANIMATION_TIMEOUT);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this._isMounted = false;
                clearTimeout(this.animationTimeout);
            }
        },
        {
            key: "componentWillReceiveProps",
            value: function componentWillReceiveProps(nextProps) {
                if (nextProps.willComponentUnmount) {
                    this.setState(function() {
                        return {
                            isComponentMounted: false
                        };
                    });
                }
            }
        },
        {
            /**
     * Toggle form on enter/space keydown
     * @params event {Object}
     */ key: "toggleFromKeyboard",
            value: function toggleFromKeyboard(event) {
                var key = event.which;
                if (key === KEY_SPACE || key === KEY_ENTER) {
                    this.props.isDeliveryAddressForm ? this.props.toggleEditForm(DELIVERY_FORM) : this.props.toggleEditForm(BILLING_FORM);
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, toggleEditForm = _this_props.toggleEditForm, classes = _this_props.classes, title = _this_props.title, subTitle = _this_props.subTitle, address = _this_props.address, isDeliveryAddressForm = _this_props.isDeliveryAddressForm, userDetails = _this_props.userDetails, sameAddress = _this_props.sameAddress, i18n = _this_props.i18n, shouldToggleWithTransition = _this_props.shouldToggleWithTransition, order = _this_props.order;
                var isComponentMounted = this.state.isComponentMounted;
                var wrapperClasses = classes;
                wrapperClasses = isComponentMounted && shouldToggleWithTransition ? "".concat(wrapperClasses, " mounted") : wrapperClasses;
                wrapperClasses = shouldToggleWithTransition ? wrapperClasses : "".concat(wrapperClasses, " no-animation");
                var hasPointerOnHeader = isDeliveryAddressForm && sameAddress && (typeof order === "undefined" || (order === null || order === void 0 ? void 0 : order.showBillingAddress));
                var hasAddress = !isDeliveryAddressForm && address && (address.firstName || address.countryName || address.phone || address.city || address.address);
                wrapperClasses = hasPointerOnHeader ? "".concat(wrapperClasses, " closed") : wrapperClasses;
                return /*#__PURE__*/ _jsxs("div", {
                    className: "information-wrapper ".concat(wrapperClasses),
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "paper-card".concat(order ? "" : " small"),
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "head".concat(hasPointerOnHeader ? " delivery pointer" : ""),
                                    onClick: hasPointerOnHeader ? function() {
                                        return toggleEditForm(DELIVERY_FORM);
                                    } : null,
                                    onKeyDown: hasPointerOnHeader ? function() {
                                        return toggleEditForm(DELIVERY_FORM);
                                    } : null,
                                    children: [
                                        /*#__PURE__*/ _jsxs("div", {
                                            children: [
                                                isDeliveryAddressForm ? /*#__PURE__*/ _jsx("span", {
                                                    className: "icon icon-local-shipping"
                                                }) : /*#__PURE__*/ _jsx("span", {
                                                    className: "icon icon-location"
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "text",
                                                    children: title
                                                })
                                            ]
                                        }),
                                        subTitle.length > 0 && /*#__PURE__*/ _jsx("div", {
                                            className: "sub-text",
                                            children: subTitle
                                        })
                                    ]
                                }),
                                isEmpty(userDetails) && /*#__PURE__*/ _jsx(CustomLoader, {
                                    i18n: i18n
                                }),
                                (isDeliveryAddressForm && !isEmpty(address) || hasAddress) && (!sameAddress || order && !order.showBillingAddress || isDeliveryAddressForm) ? /*#__PURE__*/ _jsxs("div", {
                                    className: "details",
                                    children: [
                                        address.firstName || address.lastName && /*#__PURE__*/ _jsxs("p", {
                                            className: "name",
                                            children: [
                                                address.firstName,
                                                " ",
                                                address.lastName
                                            ]
                                        }),
                                        address.countryName && /*#__PURE__*/ _jsx("p", {
                                            children: address.countryName
                                        }),
                                        address.phone && /*#__PURE__*/ _jsx("p", {
                                            children: address.phone
                                        }),
                                        address.city || address.zip && /*#__PURE__*/ _jsxs("p", {
                                            children: [
                                                address.city,
                                                " ",
                                                address.zip
                                            ]
                                        }),
                                        address.address && /*#__PURE__*/ _jsx("p", {
                                            children: address.address
                                        })
                                    ]
                                }) : null
                            ]
                        }),
                        !sameAddress || order && !order.showBillingAddress ? /*#__PURE__*/ _jsx(Button, {
                            classes: {
                                label: "ux-button-label"
                            },
                            variant: "outlined",
                            className: "footer pointer".concat(isEmpty(userDetails) ? " no-events" : ""),
                            tabIndex: "0",
                            onKeyDown: this.toggleFromKeyboard,
                            onClick: isDeliveryAddressForm ? function() {
                                return toggleEditForm(DELIVERY_FORM);
                            } : function() {
                                return toggleEditForm(BILLING_FORM);
                            },
                            children: isDeliveryAddressForm ? /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "icon icon-local-shipping"
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        children: i18n.account.changeDeliveryAddress
                                    })
                                ]
                            }) : /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "icon icon-location"
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        children: i18n.account.changeInvoiceAddress
                                    })
                                ]
                            })
                        }) : null
                    ]
                });
            }
        }
    ]);
    return UserAddress;
}(Component);
export default UserAddress;
